module.exports = __webpack_public_path__ + "media/images/p-about/example/dummy-1cc5a36e906d958a0f420bf54476ba69.png";